import ninegrid from "../index.js";

export class ngTableWrapper
{
	constructor(owner) {
		
		this.___owner = owner;
		
		this.columns_BAK = {
			getBindCol	: (colnm, first)		=> { return this.___getBindCol	(colnm, first); },
			insert		: (colnm, xml, first)	=> { return this.___insertCol		(colnm, xml, first); },
		};

		/**
		 * columns
		 */
		this.___getBindCol = (colNm, isFirst) => {
	
			if (isFirst == undefined) isFirst = true;
			
			var arr = [];
			
			$(this.___owner.template).find('th,td').each((index,el) => {
				if (el.dataset.bind == colNm) {
					arr.push(parseInt(el.dataset.col));
				}
			});
	
			return arr.length > 0 ? (isFirst ? arr[0] : arr[arr.length-1]) : -1;
		}
		
		this.___insertCol = (col, xml, isFirst) => {
	
			if (!['string','number'].includes(typeof col)) throw `invalid argument : "${col}"`;
	
			if (isFirst == undefined) isFirst = true;
			
			if (typeof col === 'string') col = this.___getBindCol(col);
	
			var nearTD = (rowIndex, col) => {
	
				var trs = [];
				$('.ng-table tr', this.___owner.body).each((index,el) => {

					if (el.rowIndex == rowIndex) {
						trs.push(el);
					}
				});
	
				var tds = [];
				for (var tr of trs) {
					$(tr).find('th,td').each((index,td) => {
						tds.push(td);
					});
				}
				
				tds.sort(function(a, b) {
					return parseInt(a.dataset.col) - parseInt(b.dataset.col);
				});
				
				for (var td of tds) {
					if (parseInt(td.dataset.col) == parseInt(col)) {
						return td;
					}
				}
			};
			
			var insertColIndicator = (col) => {
				var toTH = $(`.col-indicator[data-col=${col}]`, this.___owner.body);
				if (toTH.length > 0) {
					$(xml).find('col').each((index,el) => {
						var w = el.getAttribute("width") || 100;
						const th = document.createElement('th');
						th.setAttribute("scope", "col");
						
						ninegrid.j.querySelectorAll(th).addClass("col-indicator");
						
						$(th).html('<div></div>').insertBefore(toTH).css({ "width" : w, "min-width" : w, });
					});
				}
				return toTH;
			};
			
			var insertedTH = insertColIndicator(col);
			if (insertedTH.length <= 0) throw 'missing col';
			
			var insertCell = (group, col) => {
				
				insertedTH.closest('table').find(`${group} tr`).each((index,toTR) => {
					
					if (group == "thead" && toTR.rowIndex == 0) return true;
					
					var toTD = $(toTR).find(`th[data-col=${col}],td[data-col=${col}]`);
					if (toTD.length > 0) {
						//var row = group == "thead" ? ((index - 1) % this.___owner.template.length) : (index % this.___owner.template.length);
						var row = (index % this.___owner.template.length);
						$(xml).find(`${group} tr`).eq(row).find('th,td').each((index,fromTD) => {
							toTR.insertBefore(fromTD, toTD[0]);
						});
					}
					else {
						/** colspan 안이면 colspan 증가 */
						for (var i = col - 1; i >= 0; i--) {
							var toTD = $(toTR).find(`th[data-col=${i}],td[data-col=${i}]`);
							if (toTD.length > 0) {
								$(xml).find(`${group} tr`).eq(0).find('th,td').each((index,fromTD) => {
									toTD[0].colSpan += fromTD.colSpan;
								});
								break;
							}
						}
					}
				});
			}
			
			insertCell("thead", col);
			insertCell("tfoot", col);
			insertCell("tbody.bindable", col);
			
			this.___owner.template.each((index,toTR) => {
	
				var toTD = $(toTR).find(`th[data-col=${col}],td[data-col=${col}]`);
				if (toTD.length > 0) {
					var row = (index % this.___owner.template.length);
					$(xml).find('tbody.bindable tr').eq(row).find('th,td').each((index,fromTD) => {
						toTR.insertBefore(fromTD, toTD[0]);
					});
				}
				else {
					/** colspan 안이면 colspan 증가 */
					for (var i = col - 1; i >= 0; i--) {
						var toTD = $(toTR).find(`th[data-col=${i}],td[data-col=${i}]`);
						if (toTD.length > 0) {
							$(xml).find('tbody.bindable tr').eq(0).find('th,td').each((index,fromTD) => {
								toTD[0].colSpan += fromTD.colSpan;
							});
							break;
						}
					}
				}
			});
			
			this.___owner.resetTemplate();
		}
		
		
		/**
		 * others
		 */
		this.height = (sectionRowIndex, h) => {
			
			
			var listTR = $(".ng-table tbody.bindable tr", this.___owner.body);
	
			listTR.each((index,el) => {
				if (sectionRowIndex == el.sectionRowIndex) {
					$("canvas.chart", el).css({ "height" : h-4 });
					$(el).css({ "height" : h });
				}
			});
			
			h = 0;
			listTR.each((index,el) => {
				if (sectionRowIndex == el.sectionRowIndex) h = Math.max($(el).height(), h);
			});
			
			h = parseInt(h);
	
			listTR.each((index,el) => {
				if (sectionRowIndex == el.sectionRowIndex) {
					$(el).css({ "height" : h });
					$(el).height(h);

				}
			});
			
			return h;
		};
		
		this.getElement = (group, row, left) => {
	
			var element;
			
			$(`.ng-table ${group} th,.ng-table ${group} td`, this.___owner.body).each((index,el) => {

				var offset = $(el).offset();
	
				if (left >= offset.left && left <= offset.left + $(el).width() && row == el.closest("tr").sectionRowIndex) {
					element = el;
					return false;
				}
			});
			
			
return element;
		}
	
		this.getElements = (group, left) => {
	
			var arr = [];		
			$(`.ng-table ${group} th,.ng-table ${group} td`, this.___owner.body).each((index,el) => {

				var offset = $(el).offset();
				if (left >= offset.left && left <= offset.left + $(el).width()) arr.push(el);
			});
			
			return arr;
		}
	

		this.mergeCell = (row1, row2, col1, col2) => {
			row1 = Math.min(row1, row2);
			row2 = Math.max(row1, row2);
			col1 = Math.min(col1, col2);
			col2 = Math.max(col1, col2);
			
			for (var i = col1; i <= col2; i++) {
				$('.ng-table tbody.bindable', this.___owner.body).rowspan(i, row1, row2);
			}
			
			$('.ng-table tbody.bindable', this.___owner.body).colspan(row1, col1, col2);
		}

		this.prev = (tdElement) => {
					
			var tr = tdElement.closest("tr");
			if (!tr) return;
			
			var group = tr.closest("tbody") ? "tbody.bindable" : (tr.closest("thead") ? "thead" : "tfoot");
			var el = $(tdElement).prev(tdElement.tagName);
			
			if (el.length <= 0) {
				var isRight = tdElement.closest(".ng-container-right") ? true : false;
				var isBody = tdElement.closest(".ng-container-body") ? true : false;

				if (isBody) {
					el = $(".ng-container-left > table > " + group + " > tr", this.___owner.body).eq(tr.sectionRowIndex).find("th:not(.dummy):last-child,td:not(.dummy):last-child");
				}
				else if (isRight) {
					el = $(".ng-container-body > table > " + group + " > tr", this.___owner.body).eq(tr.sectionRowIndex).find("th:not(.dummy):last-child,td:not(.dummy):last-child");
				}
			}
			
			return el;
		};
		
		this.next = (tdElement) => {
			
			var tr = tdElement.closest("tr");
			if (!tr) return;
			
			var group = tr.closest("tbody") ? "tbody.bindable" : (tr.closest("thead") ? "thead" : "tfoot");
			var el = $(tdElement).next(tdElement.tagName);
			
			if (el.length <= 0) {
				var isLeft = tdElement.closest(".ng-container-left") ? true : false;
				var isBody = tdElement.closest(".ng-container-body") ? true : false;
	
				if (isBody) {
					el = $(".ng-container-right > table > " + group + " > tr", this.___owner.body).eq(tr.sectionRowIndex).find("th:first-child,td:first-child");
				}
				else if (isLeft) {
					el = $(".ng-container-body > table > " + group + " > tr", this.___owner.body).eq(tr.sectionRowIndex).find("th:first-child,td:first-child");
				}
			}
			
			return el;
		};
		
		this.isFirst = (tdElement) => {
			var el = this.prev(tdElement);
			return !el || el.length <= 0 ? true : false;
		};
		
		this.isLast = (tdElement) => {
			var el = this.next(tdElement);
			return !el || el.length <= 0 ? true : false;
		};
		
	}
	
	
	get rows() {
		var bodyRows	= this.___owner.body.querySelector('.ng-container-body .ng-table').rows;
		var leftRows	= this.___owner.body.querySelector('.ng-container-left .ng-table').rows;
		var rightRows	= this.___owner.body.querySelector('.ng-container-right .ng-table').rows;
		
		var rows = [];

		for (var i=0; i < leftRows.length; i++){
			rows.push(leftRows[i]);
		}
		
		for (var i=0; i < bodyRows.length; i++){
			rows.push(bodyRows[i]);
		}

for (var i=0; i < rightRows.length; i++){
			rows.push(rightRows[i]);
		}

		return rows;
	};
	
	
}
